import { Modal, Typography, Image } from "antd";
import LOGO from "./../../../../assets/tinyimg/logo.webp";
import { useContext } from "react";
import { UserInfo } from "../../../../context";
import moment from "moment";

const PayrollSummary = ({ open, close, selectedData }) => {
  const { userData } = useContext(UserInfo);

  const calculateOT = (minutes, costperminute) => {
    var total = minutes * costperminute;
    return total;
  };

  return (
    <Modal
      title=""
      open={open}
      onCancel={() => close()}
      //   closable={false}
      footer={null}
      // width={450}
      centered
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Image
          width={"auto"}
          height={80}
          src={
            userData.data.usersmerinfo.business_logo !== null
              ? `${import.meta.env.VITE_API_IMAGE}logo/${
                  userData.data.usersmerinfo.business_logo
                }`
              : LOGO
          }
          placeholder={"logo"}
          preview={false}
          alt="logo"
        />
        <Typography style={{ fontWeight: "bold", fontSize: 18, marginTop: 10 }}>
          {userData.data.usersmerinfo.business_name}
        </Typography>
        <Typography style={{ textTransform: "uppercase", fontStyle: "italic" }}>
          {userData.data.usersmerinfo.business_street !== null &&
            `${userData.data.usersmerinfo.business_street},`}{" "}
          {userData.data.usersmerinfo.business_barangay !== null &&
            `${userData.data.usersmerinfo.business_barangay},`}{" "}
          {userData.data.usersmerinfo.business_city !== null &&
            `${userData.data.usersmerinfo.business_city},`}
        </Typography>
      </div>
      <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
        <div>
          <Typography>Employee Name:</Typography>
          <Typography>Covered Period:</Typography>
          <Typography>Present count:</Typography>
          <Typography>Absent count:</Typography>
        </div>
        <div>
          <Typography>
            {selectedData.employeedetails.firstname}{" "}
            {selectedData.employeedetails.lastname}
          </Typography>
          <Typography>
            {moment
              .utc(new Date(selectedData.date_from))
              .format("MMM DD, YYYY")}{" "}
            -{" "}
            {moment.utc(new Date(selectedData.date_to)).format("MMM DD, YYYY")}
          </Typography>
          <Typography>{selectedData.present_count} day(s)</Typography>
          <Typography>{selectedData.absent_count} day(s)</Typography>
        </div>
      </div>
      {/* {console.log("SELECTED DATA: ", selectedData)} */}
      <div style={{ display: "flex", width: "100%" }}>
        <div
          style={{
            display: "flex",
            width: "calc(100% / 3)",
            flexDirection: "column",
            border: "1px solid #e5e5e5",
          }}
        >
          <Typography>Gross Pay:</Typography>
        </div>
        <div
          style={{
            display: "flex",
            width: "calc(100% / 3)",
            flexDirection: "column",
            border: "1px solid #e5e5e5",
          }}
        >
          <Typography> </Typography>
        </div>
        <div
          style={{
            display: "flex",
            width: "calc(100% / 3)",
            flexDirection: "column",
            border: "1px solid #e5e5e5",
          }}
        >
          <Typography style={{ textAlign: "right" }}>
            &#8369;{" "}
            {parseFloat(selectedData.salary).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
        </div>
      </div>
      {selectedData.employeeovertime !== undefined &&
        selectedData.employeeovertime !== null &&
        selectedData.employeeovertime.length > 0 && (
          <>
            <div style={{ display: "flex", width: "100%" }}>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "column",
                  border: "1px solid #e5e5e5",
                }}
              >
                <Typography>Overtime:</Typography>
              </div>
            </div>
            {selectedData.employeeovertime.map((data, index) => (
              <div style={{ display: "flex", width: "100%" }} key={index}>
                <div
                  style={{
                    display: "flex",
                    width: "calc(100% / 3)",
                    flexDirection: "column",
                    border: "1px solid #e5e5e5",
                    justifyContent: "center",
                  }}
                >
                  <Typography style={{ marginLeft: 5 }}>
                    &bull;{" "}
                    {moment(`${data.ot_date}T${data.ot_time_out}`).format(
                      "MMM. DD, YYYY"
                    )}{" "}
                    {moment(`${data.ot_date}T${data.ot_time_in}`).format(
                      "hh:mm A"
                    )}{" "}
                    -{" "}
                    {moment(`${data.ot_date}T${data.ot_time_out}`).format(
                      "hh:mm A"
                    )}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    width: "calc(100% / 3)",
                    flexDirection: "column",
                    border: "1px solid #e5e5e5",
                  }}
                >
                  <Typography />
                </div>
                <div
                  style={{
                    display: "flex",
                    width: "calc(100% / 3)",
                    flexDirection: "column",
                    border: "1px solid #e5e5e5",
                    justifyContent: "center",
                  }}
                >
                  <Typography style={{ textAlign: "right" }}>
                    {parseFloat(
                      calculateOT(data.ot_minutes, data.ot_per_minute)
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                </div>
              </div>
            ))}
            <div style={{ display: "flex", width: "100%" }}>
              <div
                style={{
                  display: "flex",
                  width: "calc(100% / 3)",
                  flexDirection: "column",
                  border: "1px solid #e5e5e5",
                }}
              >
                <Typography>Total Overtime:</Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  width: "calc(100% / 3)",
                  flexDirection: "column",
                  border: "1px solid #e5e5e5",
                }}
              >
                <Typography />
              </div>
              <div
                style={{
                  display: "flex",
                  width: "calc(100% / 3)",
                  flexDirection: "column",
                  border: "1px solid #e5e5e5",
                }}
              >
                <Typography style={{ textAlign: "right" }}>
                  &#8369;{" "}
                  {parseFloat(selectedData.total_overtime).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}
                </Typography>
              </div>
            </div>
          </>
        )}

      {parseFloat(selectedData.under_mins) !== 0 ||
      parseFloat(selectedData.late_mins) !== 0 ? (
        <div style={{ display: "flex", width: "100%" }}>
          <div
            style={{
              display: "flex",
              width: "calc(100% / 3)",
              flexDirection: "column",
              border: "1px solid #e5e5e5",
            }}
          >
            <Typography>Late/Undertime:</Typography>
          </div>
          <div
            style={{
              display: "flex",
              width: "calc(100% / 3)",
              flexDirection: "column",
              border: "1px solid #e5e5e5",
            }}
          >
            <Typography style={{ textAlign: "right" }}>
              &#8369;{" "}
              {parseFloat(
                (parseFloat(selectedData.late_mins) +
                  parseFloat(selectedData.under_mins)) *
                  parseFloat(selectedData.per_mins)
              ).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              width: "calc(100% / 3)",
              flexDirection: "column",
              border: "1px solid #e5e5e5",
            }}
          >
            <Typography> </Typography>
          </div>
        </div>
      ) : null}

      {selectedData.employeedeductions !== undefined &&
        selectedData.employeedeductions !== null &&
        selectedData.employeedeductions.length > 0 && (
          <>
            <div style={{ display: "flex", width: "100%" }}>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "column",
                  border: "1px solid #e5e5e5",
                }}
              >
                <Typography>Deductions:</Typography>
              </div>
            </div>
            {selectedData.employeedeductions.map((data, index) => (
              <div style={{ display: "flex", width: "100%" }} key={index}>
                <div
                  style={{
                    display: "flex",
                    width: "calc(100% / 3)",
                    flexDirection: "column",
                    border: "1px solid #e5e5e5",
                    justifyContent: "center",
                  }}
                >
                  <Typography style={{ marginLeft: 5 }}>
                    &bull; {data.description}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    width: "calc(100% / 3)",
                    flexDirection: "column",
                    border: "1px solid #e5e5e5",
                    justifyContent: "center",
                  }}
                >
                  <Typography style={{ textAlign: "right" }}>
                    {parseFloat(data.amount).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    width: "calc(100% / 3)",
                    flexDirection: "column",
                    border: "1px solid #e5e5e5",
                  }}
                >
                  <Typography />
                </div>
              </div>
            ))}
            <div style={{ display: "flex", width: "100%" }}>
              <div
                style={{
                  display: "flex",
                  width: "calc(100% / 3)",
                  flexDirection: "column",
                  border: "1px solid #e5e5e5",
                }}
              >
                <Typography>Total Deductions:</Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  width: "calc(100% / 3)",
                  flexDirection: "column",
                  border: "1px solid #e5e5e5",
                }}
              >
                <Typography style={{ textAlign: "right" }}>
                  &#8369;{" "}
                  {parseFloat(
                    parseFloat(selectedData.total_deductions) +
                      (parseFloat(selectedData.late_mins) +
                        parseFloat(selectedData.under_mins)) *
                        parseFloat(selectedData.per_mins)
                  ).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  width: "calc(100% / 3)",
                  flexDirection: "column",
                  border: "1px solid #e5e5e5",
                }}
              >
                <Typography> </Typography>
              </div>
            </div>
          </>
        )}

      <div style={{ display: "flex", width: "100%" }}>
        <div
          style={{
            display: "flex",
            width: "calc(100% / 3)",
            flexDirection: "column",
            border: "1px solid #e5e5e5",
          }}
        >
          <Typography>Net Pay:</Typography>
        </div>
        <div
          style={{
            display: "flex",
            width: "calc(100% / 3)",
            flexDirection: "column",
            border: "1px solid #e5e5e5",
          }}
        >
          <Typography> </Typography>
        </div>
        <div
          style={{
            display: "flex",
            width: "calc(100% / 3)",
            flexDirection: "column",
            border: "1px solid #e5e5e5",
          }}
        >
          <Typography style={{ textAlign: "right" }}>
            &#8369;{" "}
            {parseFloat(selectedData.gross_salary).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
        </div>
      </div>
      <div style={{ marginTop: 20 }}>
        <div>
          <Typography style={{ fontStyle: "italic" }}>Formula:</Typography>
          <Typography style={{ fontStyle: "italic", fontWeight: "bold" }}>
            (Gross Pay - Late/Undertime) - Deduction + Overtime = Net Pay
          </Typography>
        </div>
      </div>
      <div style={{ marginTop: 20 }}>
        <div>
          <Typography style={{ fontStyle: "italic" }}>Summary:</Typography>
          <Typography style={{ fontStyle: "italic", fontWeight: "bold" }}>
            The net pay is &#8369;{" "}
            {parseFloat(selectedData.gross_salary).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
        </div>
      </div>
    </Modal>
  );
};

export default PayrollSummary;
